import { ChevronRight } from "lucide-react"

const ActivityCard = ({ onClick, icon, iconContainerClass, title, children }) => (
  <div
    onClick={onClick}
    className="card w-full bg-white border border-base-200 shadow-sm rounded-2xl overflow-hidden hover:shadow-md cursor-pointer transition-all duration-300"
  >
    <div className="card-body p-5 flex flex-row items-center gap-4">
      <div className={`flex items-center justify-center w-11 h-11 rounded-full shrink-0 ${iconContainerClass}`}>
        {icon}
      </div>

      <div className="flex flex-col">
        <h1 className="text-sm font-semibold text-secondary-900 leading-snug">{title}</h1>
        {children}
      </div>

      <ChevronRight size={22} className="ml-auto text-secondary-400 shrink-0" />
    </div>
  </div>
)

export default ActivityCard
